export default __webpack_public_path__ + "static/hero-8b9d781206de26a1e2fb0031b46bcf98.svg";